import React, { useEffect, useState } from "react";
import classes from "../../../assets/styles/PageComponentsStyles/Function/Card.module.css";
import Image from "react-bootstrap/Image";
import baseURL from "../../../utils/constants/baseUrl";
import { FiMail } from "react-icons/fi";
import { MdLocationOn } from "react-icons/md";
import { BsGlobe, BsFillTelephoneFill } from "react-icons/bs";
import { MdClose } from "react-icons/md";
import { GiShare } from "react-icons/gi";
import { CARD_VCF_FILE_URL } from "../../../utils/constants/apiUrl";
import { useNavigate, useParams } from "react-router-dom";
import { post } from "../../../server/index";
import pictureicon from "../../../assets/images/function_page_icons/pictureicon.svg";
import companylogo from "../../../assets/images/function_page_icons/companylogo.svg";
import contacticon from "../../../assets/images/function_page_icons/contacticon.svg";
import playstore from "../../../assets/images/footer_icons/playstore.svg";
import appstore from "../../../assets/images/footer_icons/appstore.svg";
import { BsFileImage } from "react-icons/bs";

import qrcode from "../../../assets/images/function_page_icons/qrcode.svg";
import { ReactComponent as HomePhoneIcon } from "../../../assets/images/function_page_icons/HomePhone.svg";
import { ReactComponent as OfficePhoneIcon } from "../../../assets/images/function_page_icons/OfficePhone.svg";
import cardEdit from "../../../assets/images/card-edit.svg";
import formatPhoneNumber from "../../../helpers/formatPhoneNumber";
import { getCardBrandingOverride } from "../../../utils/cardBrandingOverrides";
import showToast from "../../../helpers/showToast";
import _ from "lodash";
import html2canvas from "html2canvas";
import AddContactModal from "../../Modals/AddContactModal";
import { loggedInUser, accountType, teamLogoAtom } from "../../../utils/store";
import { useAtom } from "jotai";
import { Button } from "react-bootstrap";
import { SlEarphonesAlt } from "react-icons/sl";

const skeletonColor = "#E8E8E8";

const tagBorderColors = {
  "#22A081": "#ABEDDD",
  "#E35252": "#C52020",
  "#E4A56B": "#DB8A3D",
  "#7000B5": "#D899FF",
  "#EEB8C9": "#E184A1",
  "#DFF87C": "#B1DA0B",
  "#34D844": "#21AB2F",
  "#3B58BD": "#9EACE0",
  "#FF5099": "#FF1A79",
};

export default function Card({
  data,
  showSidebar = false,
  handleClose,
  handleQrOpen,
  handleShareOpen,
  shareOpen,
  showCountryCodeSeparate,
  inViewMode = false,
  hideHeader = false,
  publicMode,
  selectedProfileShape,
  selectedLogoShape,
  showFooter = true,
  preferCardBackground = false,
  preferCardColor = false,
  preferCardLogo = false,
}) {
  const navigate = useNavigate();
  const [loggedUser] = useAtom(loggedInUser);
  const [personalAccount] = useAtom(accountType);
  const [teamLogoUrl] = useAtom(teamLogoAtom);
  const brandingOverride = getCardBrandingOverride(data?.id, data?.uuid);
  const teamLogo =
    data?.team?.logo ||
    (!personalAccount ? loggedUser?.teams?.logo || teamLogoUrl : null);
  const teamBackground =
    data?.team?.card_background_image ||
    (!personalAccount ? loggedUser?.teams?.card_background_image : null);
  const teamCardColor =
    data?.team?.card_color ||
    (!personalAccount ? loggedUser?.teams?.card_color : null);
  const effectiveLogo = preferCardLogo
    ? data?.logo || teamLogo
    : brandingOverride.logo || data?.logo || teamLogo;
  const effectiveBackground = preferCardBackground
    ? data?.background_image || teamBackground
    : brandingOverride.background_image ||
      data?.background_image ||
      teamBackground;
  const effectiveColor = preferCardColor
    ? data?.color || teamCardColor
    : brandingOverride.color || data?.color || teamCardColor;

  const { id, uuid } = useParams();
  const [address, setAddress] = useState("");
  const [showFullText, setShowFullText] = useState(false);
  const displayText = showFullText
    ? data?.description
    : data?.description?.length > 60
      ? data?.description?.slice(0, 60) + "..."
      : data?.description;

  const toggleText = () => {
    setShowFullText(!showFullText);
  };

  let showCountryCodeSeparateUpdate = showCountryCodeSeparate;
  let checkPath = window.location.pathname;
  if (checkPath.includes("viewcontact") || checkPath.includes("share")) {
    showCountryCodeSeparateUpdate = true;
  }
  useEffect(() => {
    if (data?.address || data?.city || data?.state || data?.country) {
      let addressArr = [];
      if (data?.address) addressArr.push(data?.address);
      if (data?.city) addressArr.push(data?.city);
      if (data?.state) addressArr.push(data?.state);
      if (data?.country) addressArr.push(data?.country);
      handleAddress(addressArr);
    }
  }, [data?.address, data?.city, data?.state, data?.country]);

  const handleAddress = (data) => {
    let commaAddress = data.join(", ");
    setAddress(commaAddress);
  };
  const [showModal, setShowModal] = useState(false);
  const handleCloseModal = () => setShowModal(false);

  // Image helper
  const getImageUrl = (path) => {
    if (!path) return "";
    const cleanPath = typeof path === 'string' ? path.trim() : String(path);
    if (cleanPath.toLowerCase().startsWith("http") || cleanPath.startsWith("data:")) return cleanPath;
    return baseURL.PUBLIC_URL + cleanPath;
  };


  const handleVcfFile = async () => {
    // setLoading(true);

    let payload = _.cloneDeep(data);
    payload["cardPhone"] = data?.card_phone;
    payload["cardSocialMedia"] = data?.card_social_media;

    delete payload.card_phone;
    delete payload.card_social_media;

    const API = `${CARD_VCF_FILE_URL}/${uuid ? uuid : payload.uuid}`;
    let {
      status,
      message,
      data: finalResult,
    } = await post(
      // CARD_VCF_FILE_URL + `/${data !== null ? data?.uuid : payload.uuid}`,
      // `/${uuid ? uuid : payload.uuid}`,
      API,
      payload
    );
    if (status) {
      // const link = document.createElement("a");
      // link.download = "temp.vcf";
      // link.href = finalResult.url;
      // link.click();

      const link = document.createElement("a");
      link.download = "temp.vcf";
      link.href = finalResult.url;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      // Simulate delay to ensure download starts
      if (
        data?.contact_exchange_form_status_team === 1 &&
        data?.team_id !== null
      ) {
        setTimeout(() => {
          if (Object.keys(loggedUser).length === 0) {
            setShowModal(true);
          }
        }, 3000);
      } else if (
        data?.contact_exchange_form_status === 1 &&
        data?.team_id === null
      ) {
        setTimeout(() => {
          if (Object.keys(loggedUser).length === 0) {
            setShowModal(true);
          }
        }, 3000);
      } else {
        setShowModal(false);
      } // delay in ms; adjust if needed
    } else {
      showToast(status, message);
    }
    // setLoading(false);
  };
  const handleSaveContact = (contactData) => {
    console.log("Saving contact:", contactData);
  };

  const handleSaveAsImage = () => {
    html2canvas(document.querySelector("#cardWrapper-new"), {
      useCORS: true,
    }).then(function (canvas) {
      const link = document.createElement("a");
      link.download = "card.png";
      link.href = canvas.toDataURL();
      link.click();
    });
  };

  const buildDisplayNumber = (singlePhone) => {
    if (!singlePhone?.phone_number) return "";

    if (!singlePhone?.country_phone) {
      return formatPhoneNumber(singlePhone.phone_number);
    }

    // This is ONLY for showing on UI, not for tel:
    return showCountryCodeSeparateUpdate
      ? `+${singlePhone.country_phone}${formatPhoneNumber(
        singlePhone.phone_number
      )}`
      : `+${singlePhone.country_phone}${formatPhoneNumber(
        singlePhone.phone_number.slice(
          String(singlePhone.country_phone).length,
          singlePhone.phone_number.length
        )
      )}`;
  };

  // THIS IS THE IMPORTANT ONE
  const buildTelHref = (singlePhone) => {
    if (!singlePhone?.phone_number) return "#";

    const countryStr = singlePhone.country_phone ? String(singlePhone.country_phone).replace(/\D/g, "") : "";
    const rawPhone = String(singlePhone.phone_number).replace(/\D/g, "");

    // Include the + if there's a country_phone or if we know it's already an international +... format
    const hasPlus = String(singlePhone.phone_number).includes('+') || countryStr;
    const baseTel = `tel:${hasPlus ? '+' : ''}${countryStr}${rawPhone}`;

    // add extension only if exists
    return singlePhone.phone_extension
      ? `${baseTel},,${singlePhone.phone_extension}`
      : baseTel;
  };

  return (
    <>
      <div className="mainDiv-new">
        <div
          className="header"
          style={uuid || hideHeader ? { display: "none" } : null}
        >
          <span className="mt-4">Card Views </span>
          {inViewMode ? (
            <MdClose onClick={handleClose ? handleClose : null} />
          ) : (
            ""
          )}
        </div>

        <div
          className="outerWrapper-new"
          style={{
            background: hideHeader && "none",
            padding: hideHeader && "0",
          }}
        >
          {showSidebar && !publicMode ? (
            <div className="shareSidebar">
              <img
                src={cardEdit}
                onClick={() => {
                  navigate(`/function/cardfunctions/${data.id}`);
                }}
                alt=""
              />
              <GiShare
                className={shareOpen ? "activeLink" : null}
                onClick={handleShareOpen}
              />
              <img
                src={qrcode}
                onClick={() => {
                  handleQrOpen();
                }}
                alt=""
              />
            </div>
          ) : null}

          <div
            className="mainWrapper-new"
            style={effectiveColor ? { '--team-card-color': effectiveColor } : undefined}
          >
            <div className="cardWrapper-new">
              <div
                className={`cardWrapper-new ${data?.content_view_type ? data.content_view_type : null
                  }`}
                id="cardWrapper-new"
              >
                <div className="imgWrapper-new imgWrapper-new-contact">
                  {/* <div className="coverImg-new">
                    {data?.background_image ? (
                      <Image
                        src={
                          typeof data?.background_image == "object"
                            ? `${URL.createObjectURL(data?.background_image)}`
                            : `${baseURL.PUBLIC_URL}${data?.background_image}`
                        }
                        alt="cover-img"
                      />
                    ) : (
                      <div style={{ backgroundColor: data?.color }} />
                    )}
                  </div> */}

                  <div
                    className="coverImg-new"
                    style={{
                      backgroundColor: effectiveColor || "var(--team-card-color, #22A081)",
                      backgroundImage:
                        effectiveBackground &&
                          String(effectiveBackground).trim() !== ""
                          ? `url(${typeof effectiveBackground === "object"
                            ? URL.createObjectURL(effectiveBackground)
                            : getImageUrl(effectiveBackground)
                          })`
                          : "none",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                      width: "100%",
                      height: "190px",
                      borderTopLeftRadius: "25px",
                      borderTopRightRadius: "25px",
                      clipPath:
                        "polygon(0 0, 100% 0, 100% 55%, 50% 90%, 0 55%)",
                    }}
                  ></div>

                  {/* <div
                key={selectedProfileShape}
                className={`${classes.profileImg} ${
                  selectedProfileShape
                    ? classes[selectedProfileShape]
                    : classes.defaultShape
                }`}
              > */}
                  <div className="business-card-profile-wraper">
                    <div
                      key={selectedProfileShape}
                      className={`profileImg ${data?.profile_image_shape
                        ? data.profile_image_shape
                        : "defaultShape"
                        } profileImg-new`}
                    >
                      {data?.profile_image ? (
                        <Image
                          src={
                            typeof data?.profile_image == "object"
                              ? `${URL.createObjectURL(data?.profile_image)}`
                              : getImageUrl(data?.profile_image)
                          }
                          onError={(e) => {
                            e.currentTarget.src = pictureicon;
                          }}
                          alt="profile-img"
                        />
                      ) : inViewMode ? (
                        <Image src={pictureicon} alt="logo-img" />
                      ) : (
                        <div
                          style={{
                            backgroundColor: skeletonColor,
                          }}
                        />
                      )}
                    </div>

                    {data?.card_type === "business" ? (
                      // <div
                      //   //className={classes.logoWrapper}
                      //   key={selectedLogoShape}
                      //   className={`${classes.logoWrapper} ${
                      //     selectedLogoShape
                      //       ? classes[selectedLogoShape]
                      //       : classes.defaultShape
                      //   }`}
                      // >
                      <div
                        key={selectedLogoShape}
                        className={`logoWrapper-new ${data?.logo_shape ? data.logo_shape : "defaultShape"
                          } logoWrapper-new`}
                      >
                        {effectiveLogo ? (
                          <Image
                            src={
                              typeof effectiveLogo == "object"
                                ? `${URL.createObjectURL(effectiveLogo)}`
                                : getImageUrl(effectiveLogo)
                            }
                            alt="logo-img"
                            onError={(e) => {
                              e.currentTarget.src = companylogo;
                            }}
                          />
                        ) : inViewMode ? null : (
                          <div style={{ backgroundColor: skeletonColor }} />
                        )}
                      </div>
                    ) : null}
                  </div>
                </div>

                <div className="infoWrapper-new mb-4">
                  <div className="leftSide-new">
                    {data?.card_type ? (
                      <div
                        className="cardType-new"
                        style={{
                          backgroundColor: data?.color
                            ? data?.color
                            : "#22A081",
                          border: `1px solid ${data?.color
                            ? tagBorderColors[`${data?.color}`]
                            : "ABEDDD"
                            }`,
                        }}
                      >
                        <span>{data?.card_type}</span>
                      </div>
                    ) : null}

                    {data?.first_name || data?.last_name ? (
                      <div
                        className="name"
                        style={{
                          color: "var(--dynamic-text-color, #232c3d)",
                        }}
                      >
                        {`${data?.first_name || ""} ${data?.last_name || ""}`}
                      </div>
                    ) : (
                      <div
                        className="textSkeleton"
                        style={{
                          width: "130px",
                          height: "17px",
                          margin: "auto",
                          marginBottom: "15px",
                        }}
                      />
                    )}

                    {(inViewMode ? data?.pronouns : true) && (
                      <>
                        {data?.pronouns ? (
                          <div
                            className="name"
                            style={{
                              color: "var(--dynamic-text-color, #232c3d)",
                              fontSize: "12px",
                              textTransform: [
                                "she/her",
                                "he/him",
                                "they/them",
                              ].includes(data?.pronouns)
                                ? "capitalize"
                                : null,
                            }}
                          >
                            {`(${data?.pronouns || ""})`}
                          </div>
                        ) : (
                          <div
                            className="textSkeleton"
                            style={{
                              width: "100px",
                              height: "12px",
                              margin: "auto",
                              marginBottom: "15px",
                              marginTop: "5px",
                            }}
                          />
                        )}
                      </>
                    )}

                    {data?.card_type === "business" ? (
                      <>
                        {(inViewMode ? data.company_position : true) && (
                          <>
                            {data.company_position ? (
                              <div className="profession-new text-center">
                                {data.company_position}
                              </div>
                            ) : (
                              <div
                                className="textSkeleton"
                                style={{
                                  width: "92px",
                                  height: "10px",
                                  margin: "auto",
                                  marginBottom: "10px",
                                }}
                              />
                            )}
                          </>
                        )}

                        {(inViewMode ? data.company : true) && (
                          <>
                            {data.company ? (
                              <div className="company text-center">
                                {data.company}
                              </div>
                            ) : (
                              <div
                                className="textSkeleton"
                                style={{
                                  width: "92px",
                                  height: "10px",
                                  margin: "auto",
                                }}
                              />
                            )}
                          </>
                        )}
                      </>
                    ) : null}
                  </div>
                </div>

                {(inViewMode ? data?.description : true) && (
                  <div className="descriptionWrapper-new">
                    <div className="leftSide">
                      {/* {data?.description ? (
                    <h6>About me</h6>
                  ) : (
                    <div
                      className={classes.textSkeleton}
                      style={{
                        width: "100px",
                        height: "13px",
                        marginBottom: "10px",
                      }}
                    />
                  )} */}
                      {data?.description ? (
                        // <span>{data.description}</span>
                        <span>
                          {displayText}
                          {data?.description?.length > 60 && (
                            <button onClick={toggleText}>
                              {showFullText ? "Show Less" : "Read More"}
                            </button>
                          )}
                        </span>
                      ) : (
                        <>
                          <div
                            className="textSkeleton"
                            style={{
                              width: "100%",
                              height: "10px",
                              marginBottom: "10px",
                              marginTop: "10px",
                            }}
                          />
                          <div
                            className="textSkeleton"
                            style={{
                              width: "100%",
                              height: "10px",
                              marginBottom: "10px",
                            }}
                          />
                          <div
                            className="textSkeleton"
                            style={{
                              width: "100%",
                              height: "10px",
                              marginBottom: "10px",
                            }}
                          />
                        </>
                      )}
                      <hr />
                    </div>
                  </div>
                )}

                {(inViewMode
                  ? data?.email ||
                  data?.address ||
                  data?.city ||
                  data?.state ||
                  data?.country ||
                  data?.website_url ||
                  data?.phone_number ||
                  data?.card_phone?.length !== 0
                  : true) && (
                    <div className={`contactInfo`}>
                      <div className="contactInfoInner">
                        {data?.email ||
                          data?.address ||
                          data?.city ||
                          data?.state ||
                          data?.country ||
                          data?.website_url ||
                          data?.phone_number ||
                          data?.card_phone?.length !== 0 ||
                          data?.contact_card_phone?.length !== 0 ? (
                          <h6>Contact Info </h6>
                        ) : (
                          <div
                            className="textSkeleton"
                            style={{
                              width: "100px",
                              height: "13px",
                              marginBottom: "10px",
                            }}
                          />
                        )}
                        {/* <hr /> */}

                        {(inViewMode ? data?.email : true) && (
                          <div
                            className={`infoContnt`}
                            style={{
                              borderColor: data.color ? data.color : "#232c3d",
                            }}
                          >
                            {data?.email || data.color ? (
                              <>
                                {data?.email ? (
                                  <a
                                    href={`mailto:${data?.email}`}
                                    style={{
                                      backgroundColor: data.color || "var(--team-card-color, #22A081)",
                                    }}
                                    className={`moreInfoIcon-new`}
                                  >
                                    {data?.email ? <FiMail /> : null}
                                  </a>
                                ) : (
                                  <div
                                    style={{
                                      backgroundColor: data.color || "var(--team-card-color, #22A081)",
                                    }}
                                    className={`moreInfoIcon-new`}
                                  >
                                    {data?.email ? <FiMail /> : null}
                                  </div>
                                )}
                              </>
                            ) : (
                              <div className="iconSkeleton" />
                            )}

                            {data.email ? (
                              <>
                                <div>
                                  <p
                                    className={`subHeading`}
                                    style={{
                                      color:
                                        "var(--dynamic-text-color, #232c3d)",
                                    }}
                                  >
                                    Email
                                  </p>
                                  {/* <a href={`mailto:${data.email}`}>{data.email}</a> */}
                                  {data.content_view_type === "iconDesign" ? (
                                    null
                                  ) : (
                                    <a href={`mailto:${data.email}`}>
                                      {data.email}
                                    </a>
                                  )}
                                </div>
                              </>
                            ) : (
                              <div
                                className="textSkeleton"
                                style={{ width: "60%", height: "10px" }}
                              />
                            )}
                          </div>
                        )}

                        {(inViewMode
                          ? data?.address ||
                          data?.city ||
                          data?.state ||
                          data?.country
                          : true) && (
                            <div
                              className={`infoContnt`}
                              style={{
                                borderColor: data.color ? data.color : "#232c3d",
                              }}
                            >
                              {data?.address ||
                                data?.city ||
                                data?.state ||
                                data?.country ||
                                data.color ? (
                                <>
                                  {data?.address ||
                                    data?.city ||
                                    data?.state ||
                                    data?.country ? (
                                    <a
                                      href={`http://maps.google.com/?q=${encodeURIComponent(
                                        address || data.address || ""
                                      )}`}
                                      style={{
                                        backgroundColor: data.color || "var(--team-card-color, #22A081)",
                                      }}
                                      className={`moreInfoIcon-new`}
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      {data?.address ||
                                        data?.city ||
                                        data?.state ||
                                        data?.country ? (
                                        <MdLocationOn />
                                      ) : null}
                                    </a>
                                  ) : (
                                    <div
                                      style={{
                                        backgroundColor: data.color || "var(--team-card-color, #22A081)",
                                      }}
                                      className={`moreInfoIcon-new`}
                                    >
                                      {data?.address ||
                                        data?.city ||
                                        data?.state ||
                                        data?.country ? (
                                        <MdLocationOn />
                                      ) : null}
                                    </div>
                                  )}
                                </>
                              ) : (
                                <div className="iconSkeleton" />
                              )}

                              {data?.address ||
                                data?.city ||
                                data?.state ||
                                data?.country ||
                                address ||
                                data.address ? (
                                <>
                                  <div>
                                    <p
                                      className={`subHeading`}
                                      style={{
                                        color:
                                          "var(--dynamic-text-color, #232c3d)",
                                      }}
                                    >
                                      Location
                                    </p>
                                    {data.content_view_type === "iconDesign" ? (
                                      null
                                    ) : (
                                      <a
                                        href={`http://maps.google.com/?q=${encodeURIComponent(
                                          address || data.address || ""
                                        )}`}
                                        target="_blank"
                                        style={{
                                          lineHeight: "1.3",
                                          display: "inline-flex",
                                          whiteSpace: "pre-line",
                                        }}
                                        rel="noreferrer"
                                      >
                                        {address || data.address}
                                      </a>
                                    )}
                                  </div>
                                </>
                              ) : (
                                <div
                                  className="textSkeleton"
                                  style={{ width: "60%", height: "10px" }}
                                />
                              )}
                            </div>
                          )}

                        {(inViewMode ? data?.website_url : true) && (
                          <div
                            className={`infoContnt`}
                            style={{
                              borderColor: data.color ? data.color : "#232c3d",
                            }}
                          >
                            {data?.website_url || data.color ? (
                              <>
                                {data?.website_url ? (
                                  <a
                                    style={{
                                      backgroundColor: data.color || "var(--team-card-color, #22A081)",
                                    }}
                                    className={`moreInfoIcon-new`}
                                    href={data?.website_url}
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    {data?.website_url ? <BsGlobe /> : null}
                                  </a>
                                ) : (
                                  <div
                                    style={{
                                      backgroundColor: data.color || "var(--team-card-color, #22A081)",
                                    }}
                                    className={`moreInfoIcon-new`}
                                  >
                                    {data?.website_url ? <BsGlobe /> : null}
                                  </div>
                                )}
                              </>
                            ) : (
                              <div className="iconSkeleton" />
                            )}

                            {data?.website_url ? (
                              <>
                                <div>
                                  <p
                                    className={`subHeading`}
                                    style={{
                                      color:
                                        "var(--dynamic-text-color, #232c3d)",
                                    }}
                                  >
                                    Website
                                  </p>
                                  {/* <a href={data?.website_url} target="_blank">
                              {data?.website_url}
                            </a> */}
                                  {data.content_view_type === "iconDesign" ? (
                                    null
                                  ) : (
                                    <a
                                      href={data?.website_url}
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      {data?.website_url}
                                    </a>
                                  )}
                                </div>
                              </>
                            ) : (
                              <div
                                className="textSkeleton"
                                style={{ width: "60%", height: "10px" }}
                              />
                            )}
                          </div>
                        )}

                        {(inViewMode ? data?.card_phone?.length !== 0 : true) && (
                          <>
                            {data?.card_phone?.map((singlePhone) => {
                              return (
                                <div
                                  className={`infoContnt`}
                                  style={{
                                    borderColor: data.color
                                      ? data.color
                                      : "#232c3d",
                                  }}
                                >
                                  {data?.color || singlePhone?.phone_number ? (
                                    <>
                                      {data?.card_phone?.length !== 0 &&
                                        singlePhone?.phone_number ? (
                                        <a
                                          href={buildTelHref(singlePhone)}
                                          style={{
                                            backgroundColor:
                                              data.color || "#22A081",
                                          }}
                                          className={`moreInfoIcon-new`}
                                          title={
                                            singlePhone.phone_extension
                                              ? `${buildDisplayNumber(
                                                singlePhone
                                              )} (Ext: ${singlePhone.phone_extension
                                              })`
                                              : buildDisplayNumber(singlePhone)
                                          }
                                        >
                                          {singlePhone.phone_number ? (
                                            <>
                                              {singlePhone.phone_type ===
                                                "home" ? (
                                                <HomePhoneIcon />
                                              ) : singlePhone.phone_type ===
                                                "office" ? (
                                                <OfficePhoneIcon />
                                              ) : singlePhone.phone_type ===
                                                "work" ? (
                                                <SlEarphonesAlt />
                                              ) : (
                                                <BsFillTelephoneFill />
                                              )}
                                            </>
                                          ) : null}
                                        </a>
                                      ) : (
                                        <div
                                          style={{
                                            backgroundColor:
                                              data.color || "#22A081",
                                          }}
                                          className={`moreInfoIcon-new`}
                                        >
                                          {singlePhone.phone_number ? (
                                            <>
                                              {singlePhone.phone_type ===
                                                "home" ? (
                                                <HomePhoneIcon
                                                  style={{
                                                    height: "20px",
                                                    width: "20px",
                                                  }}
                                                />
                                              ) : singlePhone.phone_type ===
                                                "office" ? (
                                                <OfficePhoneIcon
                                                  style={{
                                                    height: "20px",
                                                    width: "20px",
                                                  }}
                                                />
                                              ) : singlePhone.phone_type ===
                                                "work" ? (
                                                <SlEarphonesAlt
                                                  style={{
                                                    height: "20px",
                                                    width: "20px",
                                                  }}
                                                />
                                              ) : (
                                                <BsFillTelephoneFill
                                                  style={{
                                                    height: "20px",
                                                    width: "20px",
                                                  }}
                                                />
                                              )}
                                            </>
                                          ) : null}
                                        </div>
                                      )}
                                    </>
                                  ) : (
                                    <div className="iconSkeleton" />
                                  )}

                                  {singlePhone.phone_number ? (
                                    <>
                                      <div>
                                        <p
                                          className={`subHeading`}
                                          style={{
                                            color:
                                              "var(--dynamic-text-color, #232c3d)",
                                          }}
                                        >
                                          Phone
                                        </p>
                                        {data.content_view_type ===
                                          "iconDesign" ? (
                                          <a href={buildTelHref(singlePhone)}>
                                            {/* <PhoneIcon /> */}
                                            {/* <img src={phoneIcon} alt="" /> */}
                                          </a>
                                        ) : (
                                          <>
                                            <a
                                              href={buildTelHref(singlePhone)}
                                              title={
                                                singlePhone.phone_extension
                                                  ? `${buildDisplayNumber(
                                                    singlePhone
                                                  )} (Ext: ${singlePhone.phone_extension
                                                  })`
                                                  : buildDisplayNumber(
                                                    singlePhone
                                                  )
                                              }
                                            >
                                              {buildDisplayNumber(singlePhone)}
                                            </a>

                                            {singlePhone.phone_extension && (
                                              <p
                                                className="phoneExtension"
                                                style={{ marginTop: "0px" }}
                                              >
                                                Extension:{" "}
                                                {singlePhone.phone_extension}
                                              </p>
                                            )}
                                          </>
                                        )}
                                      </div>
                                    </>
                                  ) : (
                                    <div
                                      className="textSkeleton"
                                      style={{ width: "60%", height: "10px" }}
                                    />
                                  )}
                                </div>
                              );
                            })}
                          </>
                        )}

                        {(inViewMode
                          ? data?.contact_card_phone?.length !== 0
                          : true) && (
                            <>
                              {data?.contact_card_phone?.map((singlePhone) => {
                                return (
                                  <div
                                    className={`infoContnt`}
                                    style={{
                                      borderColor: data.color
                                        ? data.color
                                        : "#232c3d",
                                    }}
                                  >
                                    {data?.color ? (
                                      <>
                                        {data?.card_phone?.length !== 0 &&
                                          singlePhone?.phone_number ? (
                                          <a
                                            href={buildTelHref(singlePhone)}
                                            style={{ backgroundColor: data.color }}
                                            className={`moreInfoIcon-new`}
                                            title={
                                              singlePhone.phone_extension
                                                ? `${buildDisplayNumber(
                                                  singlePhone
                                                )} (Ext: ${singlePhone.phone_extension
                                                })`
                                                : buildDisplayNumber(singlePhone)
                                            }
                                          >
                                            {singlePhone.phone_number ? (
                                              <>
                                                {singlePhone.phone_type ===
                                                  "home" ? (
                                                  <HomePhoneIcon />
                                                ) : singlePhone.phone_type ===
                                                  "office" ? (
                                                  <OfficePhoneIcon />
                                                ) : singlePhone.phone_type ===
                                                  "work" ? (
                                                  <SlEarphonesAlt />
                                                ) : (
                                                  <BsFillTelephoneFill />
                                                )}
                                              </>
                                            ) : null}
                                          </a>
                                        ) : (
                                          <div
                                            style={{ backgroundColor: data.color }}
                                            className={`moreInfoIcon-new`}
                                          >
                                            {singlePhone.phone_number ? (
                                              <>
                                                {singlePhone.phone_type ===
                                                  "home" ? (
                                                  <HomePhoneIcon />
                                                ) : singlePhone.phone_type ===
                                                  "office" ? (
                                                  <OfficePhoneIcon />
                                                ) : singlePhone.phone_type ===
                                                  "work" ? (
                                                  <SlEarphonesAlt />
                                                ) : (
                                                  <BsFillTelephoneFill />
                                                )}
                                              </>
                                            ) : null}
                                          </div>
                                        )}
                                      </>
                                    ) : (
                                      <div className="iconSkeleton" />
                                    )}

                                    {singlePhone.phone_number ? (
                                      <>
                                        <div>
                                          <p
                                            className={`subHeading`}
                                            style={{
                                              color:
                                                "var(--dynamic-text-color, #232c3d)",
                                            }}
                                          >
                                            Phone
                                          </p>
                                          {data.content_view_type ===
                                            "iconDesign" ? (
                                            null
                                          ) : (
                                            <>
                                              <a
                                                href={buildTelHref(singlePhone)}
                                                title={
                                                  singlePhone.phone_extension
                                                    ? `${buildDisplayNumber(
                                                      singlePhone
                                                    )} (Ext: ${singlePhone.phone_extension
                                                    })`
                                                    : buildDisplayNumber(
                                                      singlePhone
                                                    )
                                                }
                                              >
                                                {buildDisplayNumber(singlePhone)}
                                              </a>

                                              {singlePhone.phone_extension && (
                                                <p
                                                  className="phoneExtension"
                                                  style={{ marginTop: "0px" }}
                                                >
                                                  Extension:{" "}
                                                  {singlePhone.phone_extension}
                                                </p>
                                              )}
                                            </>
                                          )}
                                        </div>
                                      </>
                                    ) : (
                                      <div
                                        className="textSkeleton"
                                        style={{ width: "60%", height: "10px" }}
                                      />
                                    )}
                                  </div>
                                );
                              })}
                            </>
                          )}
                      </div>
                    </div>
                  )}

                {(inViewMode
                  ? data?.card_social_media?.length !== 0
                  : true) && (
                    <div className={`socialMediaWrapper-new mb-3`}>
                      {data?.card_social_media?.length !== 0 ? (
                        <h6 className="mb-3">Social Media</h6>
                      ) : (
                        <div
                          className="textSkeleton"
                          style={{
                            width: "100px",
                            height: "13px",
                            marginBottom: "10px",
                          }}
                        />
                      )}
                      {/* <hr /> */}

                      <div className="socialMediaIconWrapper-new">
                        {data?.card_social_media?.map((single, index) => (
                          <>
                            <a
                              key={`socialMediaCard${index}`}
                              style={{ backgroundColor: data.color }}
                              className="socialMediaIcon"
                              href={single.url}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {single.icon === "custom"
                                ? single.custom_label.charAt(0)
                                : single.icon}
                            </a>
                          </>
                        ))}
                        {data?.card_social_media?.length === 0 ? (
                          <>
                            {data.color ? (
                              <>
                                <div
                                  style={{ backgroundColor: data.color }}
                                  className="iconSkeleton"
                                />
                                <div
                                  style={{ backgroundColor: data.color }}
                                  className="iconSkeleton"
                                />
                              </>
                            ) : (
                              <>
                                <div className="iconSkeleton" />
                                <div className="iconSkeleton" />
                              </>
                            )}
                          </>
                        ) : null}
                      </div>
                    </div>
                  )}

                {(inViewMode
                  ? data?.contact_card_other_data?.length !== 0
                  : true) && !data.contact_card_other_data ? (
                  ""
                ) : (
                  <>
                    {data.contact_card_other_data?.length !== 0 ? (
                      <div className={`contactInfo `}>
                        <div className="contactInfoInner">
                          {data.contact_card_other_data?.length !== 0 ? (
                            <>
                              <h6>Other Info</h6>
                            </>
                          ) : (
                            ""
                          )}
                          {data.contact_card_other_data?.map((item, index) => (
                            <>
                              <div
                                className={`infoContnt mt-0`}
                                style={{
                                  borderColor: data.color
                                    ? data.color
                                    : "#232c3d",
                                }}
                              >
                                <div key={index}>
                                  {item.type === "heading" ||
                                    item.type === "paragraph" ||
                                    item.type === "list" ||
                                    item.type === "line" ? (
                                    ""
                                  ) : (
                                    <>
                                      <p
                                        className={`subHeading mt-3`}
                                        style={{
                                          color:
                                            "var(--dynamic-text-color, #232c3d)",
                                        }}
                                      >
                                        {item.label}
                                      </p>
                                      <p>{item.data}</p>
                                    </>
                                  )}
                                </div>
                              </div>
                            </>
                          ))}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </>
                )}
              </div>

              {inViewMode ? (
                <div className={`text-center mobileViewWrapper d-block`}>
                  <Button
                    className="mx-1 mb-2 mb-lg-0"
                    onClick={() => {
                      handleVcfFile();

                      // else {
                      //   handleVcfFile();
                      // }
                    }}
                  >
                    Save Contact
                  </Button>
                  <AddContactModal
                    data={data}
                    show={showModal}
                    handleClose={handleCloseModal}
                    handleSave={handleSaveContact}
                  />
                  <Button
                    className="mx-1 mb-2 mb-lg-0"
                    onClick={handleSaveAsImage}
                  >
                    Save as Image
                  </Button>
                </div>
              ) : null}
            </div>
            {uuid && showFooter ? (
              <div className="cardFooter">
                <div className="d-flex align-items-center gap-3 justify-content-center">
                  <a
                    href="https://play.google.com/store/apps/details?id=com.contactco.contactapp"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src={playstore} alt="" />
                  </a>
                  <a
                    href="https://apps.apple.com/us/app/contact-co-connect-smarter/id6683301913"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src={appstore} alt="" />
                  </a>
                </div>
                <p>
                  © {new Date().getFullYear()} Contact Co, All rights reserved.
                </p>
              </div>
            ) : null}
          </div>
        </div>
      </div>
      <style type="text/css">
        {`
          .listDesign {
            //background-color: #e1e17d;
          }
          
          .gridDesign .contactInfoInner {
            display: flex;
            flex-wrap: wrap;
            justify-content:space-between;
          }
          .gridDesign .infoContnt {
            width: 48%;
            flex: 0 0 auto;
            padding: 0.5rem;
            display: block;id
            text-align: center;
            border:1px solid var(--tertiary_color);
            background:var(--table-color);
            border-radius: 5px;
          }
          .treeDesign .contactInfoInner h6, .treeDesign .contactInfoInner .infoContnt{
            position:relative;
          }
          .gridDesign .infoContnt a{
            // white-space:normal;
            //display: inline-flex;
            word-break: break-word;
          }
          .gridDesign .contactInfo h6{
            width:100%;
          }
          .gridDesign .moreInfoIcon{
            max-width:38px;
            max-height:38px;
            margin:0 0 10px;
          }
          .treeDesign .contactInfoInner{position:relative;padding-left:15px}
          .treeDesign .contactInfoInner:before{
            content:"";
            border-left: 1px solid var(--primary_button_color);
            height: 100%;
            position: absolute;id
            top: 13px;
            left: 0px;
          }

          .treeDesign .contactInfoInner h6{
            background-color: #464646;
            color: var(--dynamic-text-color);
            padding: 0.2rem 0.75rem;
            display:inline-block;
          }
          .treeDesign .contactInfoInner h6:before{
            content:"";
            width: 15px;
            position: absolute;
            left: -15px;
            top: 0px;
            bottom: 0;
            height: 1px;
            margin: auto;id
            position: absolute;
            height: 1px;
            background-color: var(--primary_button_color);
            left: -15px;
            top: 0;
            bottom: 0;
            margin: auto;
          }
          .treeDesign .contactInfoInner .infoContnt:before{
            content:"";
            width: 15px;
            position: absolute;
            height: 1px;
            background-color: var(--primary_button_color);
            left: -15px;
            top: 0;
            bottom: 0;
            margin: auto;
          }
          .treeDesign .contactInfoInner .infoContnt:after{
            content:"";
            width: 5px;
            height: 5px;
            background-color: var(--primary_button_color);
            border-radius: 50%;
            position: absolute;
            left: -2.4%;
          }
          .iconDesign .contactInfoInner{
            display:flex;
            flex-wrap:wrap;
            align-items:center;
            gap:12px;
          }
          .iconDesign .contactInfo h6{
            width:100%;
          }
          .iconDesign .contactInfoInner .infoContnt{
            width:auto;
            flex: 0 0 auto;
            margin:0;
          }
          .iconDesign .contactInfoInner .infoContnt > div{
            display:none;
          }
          .iconDesign .contactInfoInner .infoContnt .moreInfoIcon{
            display:none;
          }
          .iconDesign .contactInfoInner .infoContnt .subHeading{
            display:none;
          }
          .profileImg.circle div,
          .profileImg.circle img {
            border-radius: 50%;
            transition: 0.5s all ease;
          }
          .profileImg.square div,
          .profileImg.square img {
            border-radius: 2px;
            transition: 0.5s all ease;
          }
          .profileImg.rectangular div,
          .profileImg.rectangular img {
            border-radius: 2px;
            width: 90px;
            height: 65px;
            transition: 0.5s all ease;
          }
          .logoWrapper{
            position: absolute;
            top: 115px;
            right: 45px;
          }
          .logoWrapper.circle div,
          .logoWrapper.circle img {
            border-radius: 50%;
            transition: 0.5s all ease;
          }
          .logoWrapper.square div,
          .logoWrapper.square img {
            border-radius: 2px;
            transition: 0.5s all ease;
          }
          .logoWrapper.rectangular div,
          .logoWrapper.rectangular img {
            border-radius: 2px;
            width: 50px;
            height: 25px;
            transition: 0.5s all ease;
          }
          .logoWrapper-new img,
          .logoWrapper-new div {
            background-color: var(--table-color, #fff) !important;
            border: 2px solid var(--border-color) !important;
          }
        `}
      </style>
    </>
  );
}
